import {React, useState} from 'react'

const defaultform = {
    displayName: '',
    email: '',
    password: '',
    confirmPassword:''
}

function SignUpForm() {
    const [formFields, setFormFields] = useState(defaultform)
    const { displayName, email, password, confirmPassword} = formFields;

    

    const handleChange = (event) => {
        const {name, value} = event.target;
        setFormFields({...formFields, [name]: value})
    }
  return (
    <div>
      <form onSubmit={()=> {}}>
        <label>Display Name</label>
        <input type='text' required onChange={handleChange} name="displayName" value={displayName} />
        
        <label>Email</label>
        <input type='email' required onChange={handleChange} name="email" value={email} />
        
        <label>Password</label>
        <input type='password' required onChange={handleChange} name="password" value={password} />
        
        <label>Confirm Password</label>
        <input type='password' required onChange={handleChange} name="confirmPassword" value={confirmPassword} />
        <button type='submit'>Sign Up</button>
      </form>
    </div>
  )
}

export default SignUpForm
